import pako, { inflateRaw } from "pako";
import commandList from "./commands"; //contains all of the command numbers in an object called usbCmd

function ToBase64(arr) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(arr)));
}

function FromBase64(str) {
    return atob(str)
        .split("")
        .map(function(c) {
            return c.charCodeAt(0);
        });
}

// monkey patch the array with a
// position variable so that we
// don't need to continually shift()
// the data while unpacking.
function createMtBuffer(data) {
    if (typeof data.mtPosition == "undefined") {
        data.mtPosition = 0;
    }
    return data;
}
// this one is useful if you know you need to start at
// the start of a buffer
function resetMtBuffer(data) {
    data.mtPosition = 0;
}

function packAscii(ascStr, buff) {
    var result;
    if (buff !== undefined) {
        result = buff;
    } else {
        result = [];
    }

    var i;
    for (i = 0; i < ascStr.length; i++) {
        result.push(ascStr.charCodeAt(i));
    }
    return result;
}

function pack8(val, buff) {
    var result;
    if (buff !== undefined) {
        result = buff;
    } else {
        result = [];
    }

    result.push(val & 0xff);
    return result;
}

function pack16(val, buff) {
    var result = pack8(val >> 8, buff);
    result = pack8(val, result);
    return result;
}

function pack32(val, buff) {
    var result = pack16(val >> 16, buff);
    result = pack16(val, result);
    return result;
}

function unpack8(data) {
    // monkey patch the array with a position indicator
    // so that we don't have to shift all of the data all the time.
    createMtBuffer(data);
    return data[data.mtPosition++];
}

function unpack16(data) {
    var result = unpack8(data) * 256;
    result += unpack8(data);
    return result;
}

function unpack32(data) {
    var result = unpack16(data) * 65536;
    result += unpack16(data);
    return result;
}

function unpackString(data) {
    var length = unpack8(data);
    var result = "";
    for (let i = 0; i < length; i++) {
        result += String.fromCharCode(unpack8(data));
    }
    return result;
}

const valueTypes = {
    VALUE_NULL: 0, // indicates there is no value, only a name.
    VALUE_UINT8: 1,
    VALUE_INT8: 2,
    VALUE_UINT16: 3,
    VALUE_INT16: 4,
    VALUE_UINT32: 5,
    VALUE_INT32: 6,
    VALUE_ARRAY: 14,
    VALUE_STRING: 15
};

function unpackValue(buffer, valueType, precision) {
    var value;
    switch (valueType) {
        case valueTypes.VALUE_NULL:
            value = null;
            break;
        case valueTypes.VALUE_UINT32:
            value = unpack32(buffer);
            value /= Math.pow(10, precision);
            //value = value.toFixed(precision);
            break;
        case valueTypes.VALUE_INT32:
            value = unpack32(buffer) >> 0;
            value /= Math.pow(10, precision);
            //value = value.toFixed(precision);
            break;
        case valueTypes.VALUE_UINT16:
            value = unpack16(buffer);
            value /= Math.pow(10, precision);
            //value = value.toFixed(precision);
            break;
        case valueTypes.VALUE_INT16:
            value = unpack16(buffer);
            if (value > 32768) {
                value = value - 65536;
            }
            value /= Math.pow(10, precision);
            //value = value.toFixed(precision);
            break;
        case valueTypes.VALUE_STRING:
            value = unpackString(buffer);
            break;
        case valueTypes.VALUE_ARRAY:
            value = unpack8(buffer);
            break;
    }
    return value;
}

// this is for decimal values packed simply
function unpackDecimal(data) {
    var valueType = unpack8(data);
    var precision = valueType & 0x0f;
    valueType >>= 4;
    return unpackValue(data, valueType, precision);
}

function unpackNameValuePair(data) {
    var valueType = unpack8(data);
    var precision = valueType & 0x0f;
    valueType >>= 4;
    var value = unpackValue(data, valueType, precision);
    var result = [unpackString(data), value];

    // for array type, also recursively pack the
    // contents of the array.
    if (valueType == valueTypes.VALUE_ARRAY) {
        result[1] = [];
        for (let i = 0; i < value; i++) {
            result[1].push(unpackNameValuePair(data));
        }
    }

    return result;
}

function buf2Hex(buffer) {
    // buffer is an Array
    return Array.prototype.map
        .call(new Uint8Array(buffer), x => ("00" + x.toString(16)).slice(-2))
        .join("")
        .toUpperCase();
}

function unpackHexString(data, len) {
    createMtBuffer(data);
    if (len === undefined) len = data.length - data.mtPosition;
    var result = buf2Hex(data.slice(data.mtPosition, data.mtPosition + len));
    data.mtPosition += len;
    return result;
}

function packHexString(strVal, buff) {
    for (var i = 0, len = strVal.length; i < len; i += 2) {
        pack8(parseInt(strVal.substr(i, 2), 16), buff);
    }
}

function fletcher16(buff) {
    //16-bit variation of fletcher proc.
    let c0, c1, i;

    // start with the length values to save messing around with pointers.
    c0 = (buff.length >> 8) & 0xff;
    c1 = c0;
    c0 += buff.length & 0xff;
    c1 += c0;

    const fin = 255;
    for (i = 0; i < buff.length; i++) {
        c0 += buff[i];
        c1 += c0;
    }
    c0 %= fin;
    c1 %= fin;
    return (c1 << 8) | c0;
}

function unpackMtPacket(buffer) {
    createMtBuffer(buffer);

    let offset = buffer.mtPosition;
    while (buffer[offset] != 0xfe) {
        if (!(offset < buffer.length)) return null; // no SOF, subsequently, no data, so return empty (null) instead of error (false)
        offset++;
    }
    let len = buffer[offset + 1] * 256 + buffer[offset + 2];
    let data = buffer.slice(offset + 3, offset + 3 + len);
    if (data.length != len) return false; // not enough data
    if (buffer.length < offset + length + 5) return false; // not enough data
    let calcChecksum = fletcher16(data);
    let specChecksum =
        buffer[offset + len + 3] * 256 + buffer[offset + len + 4];
    if (specChecksum != calcChecksum) return false; // bad checksum
    // if the checksum is good, then consume the bytes in the buffer
    // (discarding any prior garbage.)
    buffer.mtPosition = offset + len + 5;
    return createMtBuffer(data);
}

function unpackFactoryConfig(response) {
    // this is a private helper function
    // for usbGetFactoryConfig and usbSetFactoryConfig
    let allowedMainsChannels = unpack32(response);
    let allowedBatteryChannels = unpack32(response);
    let modemInstalled = unpack32(response);
    return {
        allowedMainsChannels,
        allowedBatteryChannels,
        modemInstalled
    };
}

export default {
    mixins: [commandList], // commandList contains all of the command numbers in an object called usbCmd
    data() {
        // group symbols to use for better organisation:

        // use the name of the input to set it's group
        // the order of this map dicates the order in which
        // traces appear on the chart
        let defaultTraceGroups = new Map();

        const LOOP_IMP = 0;
        const VOLTAGE = 1;
        const CURRENT = 2;
        const TEST_VOLTAGE = 3;
        const TEST_CURRENT = 4;
        const DIAG_VOLT = 7;
        const DIAG_TEMP = 8;

        defaultTraceGroups.set("CLI", LOOP_IMP);
        defaultTraceGroups.set("LI", LOOP_IMP);
        defaultTraceGroups.set("CNI", LOOP_IMP);
        defaultTraceGroups.set("NI", LOOP_IMP);

        defaultTraceGroups.set("VA", VOLTAGE);
        defaultTraceGroups.set("VB", VOLTAGE);
        defaultTraceGroups.set("VC", VOLTAGE);

        defaultTraceGroups.set("IA", CURRENT);

        defaultTraceGroups.set("PRE", TEST_VOLTAGE);
        defaultTraceGroups.set("DUR", TEST_VOLTAGE);
        defaultTraceGroups.set("POST", TEST_VOLTAGE);

        defaultTraceGroups.set("LOAD", TEST_CURRENT);

        defaultTraceGroups.set("VCC", DIAG_VOLT);

        defaultTraceGroups.set("TEMP", DIAG_TEMP);

        // trace groups (for each different type of chart)
        let groupNames = [];
        groupNames[LOOP_IMP] = "Loop Impedance";
        groupNames[VOLTAGE] = "Mains Voltage";
        groupNames[CURRENT] = "Idle Current";
        groupNames[TEST_VOLTAGE] = "Test Voltage";
        groupNames[TEST_CURRENT] = "Test Current";
        groupNames[DIAG_VOLT] = "Device Internal Voltages";
        groupNames[DIAG_TEMP] = "Device Internal Temperatures";

        // default Y axis ranges
        let groupRanges = [];
        groupRanges[LOOP_IMP] = [0, null];
        groupRanges[VOLTAGE] = [200, 260];
        groupRanges[CURRENT] = [null];
        groupRanges[TEST_VOLTAGE] = [180, 280];
        groupRanges[TEST_CURRENT] = [null];
        groupRanges[DIAG_VOLT] = null;
        groupRanges[DIAG_TEMP] = null;

        // default limit bars for the group
        let groupLimitBars = [];
        groupLimitBars[LOOP_IMP] = [NaN, NaN];
        groupLimitBars[VOLTAGE] = [230 * 0.94, 230 * 1.1];
        groupLimitBars[CURRENT] = [NaN, NaN];
        groupLimitBars[TEST_VOLTAGE] = [NaN, NaN];
        groupLimitBars[TEST_CURRENT] = [NaN, NaN];
        groupLimitBars[DIAG_VOLT] = [NaN, NaN];
        groupLimitBars[DIAG_TEMP] = [NaN, NaN];

        return {
            usbOk: true,
            txBuffer: new Uint8Array(512),
            // use the name of the input to set it's color
            defaultTraceColors: {
                CLI: "red",
                LI: "#F9A602", //Gold (dark yellow)
                CNI: "black",
                NI: "blue",
                VA: "red",
                VB: "#F9A602", //Gold (dark yellow)
                VC: "blue",
                IA: "red",
                PRE: "red",
                DUR: "black", //Gold (dark yellow)
                POST: "blue",
                LOAD: "black",
                VCC: "blue",
                TEMP: "red"
            },

            // use the name of the input to get a full title
            traceTitles: {
                CLI: "Compensated Loop Impedance",
                LI: "Loop Impedance",
                CNI: "Compensated Neutral Impedance",
                NI: "Neutral Impedance",
                VA: "A Phase Mains Voltage",
                VB: "B Phase Mains Voltage",
                VC: "C Phase Mains Voltage",
                IA: "Idle Load Current",
                PRE: "Test Voltage Pre-Load",
                DUR: "Test Voltage Under Load",
                POST: "Test Voltage Post-Load",
                LOAD: "Test Current",
                VCC: "MCU VCC",
                TEMP: "MCU TEMPERATURE"
            },

            // this object is used to describe the
            // generated traces and their relationship
            // to recorded traces.
            // eg: generatedTraces : [{
            //      name: "WA",
            //      requires: ['IA', 'VA', 'PAA'],
            //      units: "kW",
            //      precision: 2,
            //      conversion: (i, v, pa) => i * v * Math.cos(pa) / 1000.0,
            //  },]
            generatedTraces: [], // removed all generated traces because they don't work with huntsman and scattered timestamps.

            defaultTraceGroups,
            groupNames,
            groupRanges,
            groupLimitBars,
            usbFileReadSize: 0,
            usbFileReadNumber: -1,
            usbFirmwareSize: 0,
            usbFirmwareProgress: 0
        };
    },
    methods: {
        ipRequest: function(query, params, body) {
            var headers = {
                Accept: "application/json"
            };

            let endpoint = "http://" + this.deviceIpAddress + ":28352/" + query;
            if (Array.isArray(params)) {
                params.forEach(val => (endpoint += "/" + val));
            } else if (params !== null && params !== undefined) {
                endpoint += "/" + params;
            }

            var options = {
                method: "POST",
                headers: headers,
                body: body
            };

            return fetch(endpoint, options)
                .then(r => {
                    if (r.status != 200) {
                        this.showError("Error during device IP operation.");
                        console.log("IP SERVER ERROR!!!");
                        console.log(r);
                        return r
                            .text()
                            .then(t => console.log(t))
                            .then(() => {
                                return {
                                    status: r.status,
                                    body: {
                                        data: ""
                                    },
                                    ok: false
                                };
                            });
                    } else {
                        return r
                            .json()
                            .then(js => {
                                this.usbOk = true;
                                return {
                                    status: r.status,
                                    body: js
                                };
                            })
                            .catch(ex => {
                                console.error(
                                    "Error decoding JSON response from ipRequest."
                                );
                                console.log(ex);
                                console.error("Content of the response was:");
                                console.log(r);
                                this.showError(
                                    "Error decoding device IP data."
                                );
                                return r
                                    .text()
                                    .then(t => console.log(t))
                                    .then(() => {
                                        return {
                                            status: 500,
                                            body: {
                                                data: ""
                                            },
                                            ok: false
                                        };
                                    });
                            });
                    }
                })
                .catch(ex => {
                    // if the driver is not installed, we get an error here
                    this.usbOk = false;
                    return {
                        status: 500,
                        body: {
                            data: ""
                        },
                        ok: false
                    };
                    // this only occurs if we are unable to complete the request
                    // for some reason, so it is only a missing/damaged usb server
                    // that can cause this problem.
                });
        },
        generateTraceGroups(header, multipleDevices) {
            if (multipleDevices) {
                console.log("devices found in store");
                const result = new Map();

                header.forEach(({ name, precision, units }, idx) => {
                    result.set(name, 0);
                    // This is to ensure that incase the predefined color list length is less than the required length then the line color defaults to red
                });
                console.log("result", result);
                return result;
            }

            return this.defaultTraceGroups;
        },
        /*
        createTraceGroups(){
            const devices = this.$store.state.devices;
            const log = this.$store.state.log;

            if (!log || !log.headers) {
                console.error("No headers found in log");
                return this.defaultTraceGroups;
            }

            // If the request is for multiple devices
            if (log && log.headers && devices && devices.length > 0) {
                const result = new Map();

                log.headers.forEach(({ name, precision, units }, idx) => {
                    result.set(name, 0);
                    // This is to ensure that incase the predefined color list length is less than the required length then the line color defaults to red
                });
                return result;
            }

            return this.defaultTraceGroups;
        },
        
        formatTraceGroups(headers, isMultipleDevices) {
            const traceGroups = new Map();

            const LOOP_IMP = 0;
            // this function is used to format the trace groups
            if (isMultipleDevices) {
                console.log(headers);
                headers.forEach(({ name, precision, units }, idx) => {
                    traceGroups.set(name, LOOP_IMP);
                    // This is to ensure that incase the predefined color list length is less than the required length then the line color defaults to red
                });
                this.traceGroups = traceGroups;
            }
        },
        */
        getValueByName(collection, name) {
            for (let i = 0; i < collection.length; i++) {
                if (collection[i][0] == name) {
                    return collection[i][1];
                }
            }
            return undefined;
        },
        cleanCollection(collection) {
            let arr = [];
            let obj = {};
            collection.forEach(item => {
                let value;
                if (Array.isArray(item[1])) {
                    value = this.cleanCollection(item[1]);
                } else {
                    value = item[1];
                }

                if (item[0] === "") {
                    obj[arr.length] = value;
                    arr.push(value);
                } else {
                    obj[item[0]] = value;
                }
            });

            if (arr.length == collection.length) {
                return arr;
            } else {
                return obj;
            }
        },
        deviceRequest: async function(command, payload, options) {
            options = Object.assign({}, options);

            let bodyObj = {
                data: {
                    command,
                    payload: ToBase64(payload)
                }
            };

            // it timeout is falsy(zero, nil, or false), it means nothing
            // so leave it out.
            if (options.timeout) {
                bodyObj.data.timeout = options.timeout;
            }

            let body = JSON.stringify(bodyObj);
            let resp = await this.ipRequest("device", null, body);
            if (resp.body.ok) {
                return createMtBuffer(FromBase64(resp.body.data));
            } else {
                return false;
            }
        },

        // a simple command with no arguments returning a 32 bit value
        async simpleCommand32(number) {
            var response = await this.deviceRequest(number, []);
            if (response === false) return response;
            else return unpack32(response);
        },

        // define calls for each request Here
        async deviceGetToken() {
            var response = await this.ipRequest("read_token");
            if (response === false) return response;
            if (response.status == 200) {
                return response.body.data.token;
            }
            return null;
        },

        // returns an array with real-time calibration readings from the device.
        async ipGetCalReadings() {
            var response = await this.deviceRequest(
                this.usbCmd.GET_CALIBRATION_READING,
                pack32(new Date().getTime() / 1000)
            );
            if (response === false) return response;
            var keyValue = [];
            keyValue.push(["TIMESTAMP", unpack32(response)]);
            while (response.mtPosition < response.length) {
                keyValue.push(unpackNameValuePair(response));
            }
            return keyValue;
        },

        async usbSetSecret(newSecret) {
            if (newSecret == null || newSecret.length != 16) {
                return false;
            }
            var buff = [];
            packHexString(newSecret, buff);
            var response = await this.deviceRequest(
                this.usbCmd.GET_SECRET,
                buff
            );
            if (response === false) return response;
            else return unpackHexString(response);
        },

        async usbGetLogFile(fileNumber, options) {
            console.log("USB get log file");
            let bytesRead = [];
            let rawFileData = [];
            let BLOCKSIZE = 2000;
            let token = options.device;
            this.usbFileReadSize = 0;
            this.usbFileReadNumber = fileNumber;

            // grab any cached data.
            if (
                this.$store.state.blobs[token] &&
                this.$store.state.blobs[token][fileNumber] != null
            ) {
                rawFileData = [...this.$store.state.blobs[token][fileNumber]];
            }

            do {
                bytesRead = await this.usbReadFile(
                    fileNumber,
                    rawFileData.length,
                    BLOCKSIZE,
                    options
                );
                rawFileData = rawFileData.concat(bytesRead);
                this.usbFileReadSize = rawFileData.length;
            } while (bytesRead.length == BLOCKSIZE);

            console.log(
                "Read file number",
                fileNumber,
                "With a size of",
                this.usbFileReadSize
            );

            this.usbFileReadSize = 0;
            this.usbFileNumber = -1;

            // cache returned blob
            this.$store.commit("setBlob", {
                fileNumber,
                token,
                data: rawFileData
            });

            let fileObject = this.decodeBinaryLogData(rawFileData);
            if (fileObject === false) return false;
            return Object.assign(
                {
                    chart_type: "Gecko Log",
                    comments: "",
                    file_number: fileNumber
                },
                fileObject
            );
        },
        // private helper.
        decodeConfigPacket(response) {
            let timeStamp = unpack32(response) * 1000;
            let allowedMainsChannels = unpack32(response);
            let enabledMainsChannels = unpack32(response);
            let allowedBatteryChannels = unpack32(response);
            let enabledBatteryChannels = unpack32(response);
            let aflcFreq = unpack16(response);
            let aflcBin = unpack16(response);
            return {
                timeStamp,
                allowedMainsChannels,
                enabledMainsChannels,
                allowedBatteryChannels,
                enabledBatteryChannels,
                aflcFreq,
                aflcBin
            };
        },
        async usbGetConfig() {
            // load the config info from the device
            var response = await this.deviceRequest(this.usbCmd.CONFIGURE, []);
            if (response === false) return response;
            return this.decodeConfigPacket(response);
        },
        async usbSetConfig(configArg) {
            // set config values in device
            var configValues = await this.usbGetConfig();
            configValues = Object.assign(configValues, configArg);
            let now = new Date();
            configValues.timeStamp = Math.floor(now.getTime() / 1000);
            let payload = pack32(configValues.timeStamp);
            pack32(configValues.enabledMainsChannels, payload);
            pack32(configValues.enabledBatteryChannels, payload);
            pack32(configValues.aflcFreq, payload);

            var response = await this.deviceRequest(
                this.usbCmd.CONFIGURE,
                payload
            );
            if (response === false) return response;
            return this.decodeConfigPacket(response);
        },

        async usbGetFirmwareVersion() {
            // get the firmware version from the logger
            var response = await this.deviceRequest(
                this.usbCmd.GET_BUILD_TIMESTAMP,
                []
            );
            if (response === false) return response;
            let batteryFirmware = unpack32(response);
            let mainsFirmware = unpack32(response);
            console.log("Battery Version:", batteryFirmware);
            console.log("Mains Version:", mainsFirmware);
        },

        // this is for loading stored logs from the server,
        // it is not strictly a USB function but it shares
        // a lot of functionality with the USB procedures.
        loadChartResponse(body) {
            let jsonString = pako.inflate(body, {
                to: "string"
            });
            let jsonData = JSON.parse(jsonString);
            let logData = this.decodeJsonLogData(jsonData);
            // freeze the readings arrays to prevent Vue.js from indexing it
            Object.freeze(logData.readings);

            this.$store.commit("setLog", logData);
            const isMultipleDevices = "devices" in jsonData.data;
            if (isMultipleDevices) {
                this.$store.commit("setDevices", jsonData.data.devices);
                this.$store.commit("setDevice", null);
            } else {
                this.$store.commit("setDevice", jsonData.data.device);
                this.$store.commit("setDevices", []);
            }
            this.$store.commit("incrementLogVersion");
        },
        // *************************************************************************************************************************************
        decodeJsonLogData(jsonData) {
            var availableChannels = [];

            const isMultipleDevices = "devices" in jsonData.data;
            const traceGroups = this.generateTraceGroups(
                jsonData.data.header,
                isMultipleDevices
            );

            let header = jsonData.data.header;
            let availableGroupIds = [];
            for (var i = 0; i < header.length; i++) {
                let groupId = traceGroups.get(header[i].name);
                availableGroupIds.push(groupId);
                header[i].groupId = groupId;
                availableChannels.push(header[i].name);
            }
            // kanderel -- This loop is not in use because it does not work with huntsman
            // work out which of the generated traces
            // have their dependencies statisfied and mark them
            for (let i = 0; i < this.generatedTraces.length; i++) {
                let gt = this.generatedTraces[i];
                gt.present = true;
                gt.requiredTraceIndices = [];
                for (let j = 0; j < gt.requires.length; j++) {
                    for (let k = 0; k < header.length; k++) {
                        // check if a trace is available, and at the same time
                        // record the index within the blob of the
                        // required readings.
                        if (header[k].name == gt.requires[j]) {
                            gt.requiredTraceIndices.push(k);
                            break;
                        }
                    }
                    if (gt.requiredTraceIndices.length != j + 1) {
                        gt.present = false;
                        break;
                    }
                }
                if (gt.present) {
                    let groupId = traceGroups.get(gt.name);
                    gt.groupId = groupId;
                    availableGroupIds.push(groupId);
                }
            }

            let availableGroups = [];
            for (let key = 0; key < availableGroupIds.length; key++) {
                let value = availableGroupIds[key];
                if (availableGroupIds.indexOf(value) == key) {
                    availableGroups.push({
                        index: value,
                        title: this.groupNames[value]
                    });
                }
            }

            // sort the available groups by index so that the array order is consistent
            availableGroups.sort((a, b) => (a.index > b.index ? 1 : -1));
            // unpack the binary data into a simple 2 dimensional array
            let readings = jsonData.data.readings;

            // convert the Unix timestamps into JS timestamps
            // also fix the precision of each reading
            readings.map(val => {
                val[0] *= 1000;
                for (let i = 1; i < val.length; i++) {
                    val[i] =
                        val[i] &&
                        parseFloat(val[i].toFixed(header[i - 1].precision));
                }
                return val;
            });

            let returnData = { readings, header };

            if (readings.length > 0) {
                returnData.started_at = new Date(readings[0][0]); // this is also stored on the server, but we do it here so that no server interatction is required when offline.
                returnData.ended_at = new Date(
                    readings[readings.length - 1][0]
                ); // provided for user information.
                let durationMin = Math.floor(
                    (readings[readings.length - 1][0] - readings[0][0]) / 60000
                );
                returnData.duration = {
                    // provided for user information.
                    days: Math.floor(durationMin / (24 * 60)),
                    hours: Math.floor(durationMin / 60) % 24,
                    minutes: durationMin % 60
                };
            } else {
                returnData.started_at = false;
                returnData.ended_at = false;
                returnData.ended_at = false;
                returnData.duration = {
                    // provided for user information.
                    days: 0,
                    hours: 0,
                    minutes: 0
                };
            }

            returnData.availableGroups = availableGroups;
            returnData.generatedTraces = this.generatedTraces;
            return returnData;
        },
        /* unused on huntsman, no longer maintained.
        decodeBinaryLogData(rawFileData) {
            resetMtBuffer(rawFileData);

            let logData = {};

            var headerBlob = unpackMtPacket(rawFileData);
            if (headerBlob === false || headerBlob == null) {
                console.error("Unable to unpack header packet in log file.");
                return false;
            }

            if (unpack16(headerBlob) != this.usbCmd.LOG_FILE_HEADER) {
                console.error(
                    "File header command ID not present in log file."
                );
                return false;
            }

            if (unpack32(headerBlob) != 0) {
                console.error("Unknown file format in log file file.");
                return false;
            }

            var availableChannels = [];

            let header = [];
            let availableGroupIds = [];
            while (headerBlob.mtPosition < headerBlob.length) {
                let name = unpackString(headerBlob);
                let valueType = unpack8(headerBlob);
                let precision = valueType & 0x0f;
                valueType >>= 4;
                let units = unpackString(headerBlob);
                let groupId = this.traceGroups.get(name);
                availableGroupIds.push(groupId);
                header.push({
                    name,
                    valueType,
                    precision,
                    units,
                    groupId
                });
                availableChannels.push(name);
            }

            // work out which of the generated traces
            // have their dependencies statisfied and mark them
            for (let i = 0; i < this.generatedTraces.length; i++) {
                let gt = this.generatedTraces[i];
                gt.present = true;
                gt.requiredTraceIndices = [];
                for (let j = 0; j < gt.requires.length; j++) {
                    for (let k = 0; k < header.length; k++) {
                        // check if a trace is available, and at the same time
                        // record the index within the blob of the
                        // required readings.
                        if (header[k].name == gt.requires[j]) {
                            gt.requiredTraceIndices.push(k);
                            break;
                        }
                    }
                    if (gt.requiredTraceIndices.length != j + 1) {
                        gt.present = false;
                        break;
                    }
                }
                if (gt.present) {
                    let groupId = this.traceGroups.get(gt.name);
                    gt.groupId = groupId;
                    availableGroupIds.push(groupId);
                }
            }

            // remove duplicate group Id's and create a proper list of available groups
            let availableGroups = [];
            for (let key = 0; key < availableGroupIds.length; key++) {
                let value = availableGroupIds[key];
                if (availableGroupIds.indexOf(value) == key) {
                    availableGroups.push({
                        index: value,
                        title: this.groupNames[value]
                    });
                }
            }

            // sort the available groups by index so that the array order is consisten
            availableGroups.sort((a, b) => (a.index > b.index ? 1 : -1));

            // unpack the binary data into a simple 2 dimensional array
            let readings = [];

            let corruptPacket = false;
            while (rawFileData.mtPosition < rawFileData.length) {
                let packet = unpackMtPacket(rawFileData);

                if (packet == null) {
                    // on null there are no more SOF bytes left in the data, subsequently, no more packets.
                    // when a file has not been finalised (closed), there is usually empty space at the end of the
                    // file due to logfs pre-allocation.
                    break;
                }

                if (packet === false) {
                    if (!corruptPacket) {
                        console.error(
                            "Corrupt packet in file at offset " +
                                rawFileData.mtPosition
                        );
                        corruptPacket = true;
                    }
                    unpack8(rawFileData); // dump a single byte and try again.
                    continue;
                } else if (corruptPacket) {
                    console.info(
                        "A good packet was decoded, ending at offset " +
                            rawFileData.mtPosition
                    );
                    corruptPacket = false;
                }

                let command = unpack16(packet);
                if (command == this.usbCmd.LOG_FILE_READING) {
                    let timestamp = unpack32(packet) * 1000;
                    //timestamp = new Date(timestamp);
                    // create a row with the timestamp.
                    //let reading = [timestamp];
                    let blobValues = [timestamp];

                    // load the hardware generated values
                    for (let i = 0; i < header.length; i++) {
                        blobValues.push(
                            unpackValue(
                                packet,
                                header[i].valueType,
                                header[i].precision
                            )
                        );
                    }
                    readings.push(blobValues);
                } else if (command == this.usbCmd.LOG_FILE_TIME) {
                    // this packet changes the clock in the logger, so we need to go back and adjust all previous timestamps.
                    let oldTimestamp = unpack32(packet) * 1000;
                    let newTimestamp = unpack32(packet) * 1000;
                    console.log("LOG_FILE_TIME packet detected.");
                    console.log(
                        "old (JS) timestamp:",
                        oldTimestamp,
                        "new (JS) timestamp:",
                        newTimestamp
                    );
                    console.log(
                        "old date:",
                        new Date(oldTimestamp),
                        "new date:",
                        new Date(newTimestamp)
                    );
                    let difference = newTimestamp - oldTimestamp;
                    for (var i = 0; i < readings.length; i++) {
                        readings[i][0] += difference;
                    }
                } else if (command == this.usbCmd.LOG_FILE_LOCATION) {
                    console.log("LOG_FILE_LOCATION packet detected.");
                    logData.latitude = unpackDecimal(packet);
                    logData.longitude = unpackDecimal(packet);
                    console.log(
                        "latitude:",
                        logData.latitude,
                        "longitude:",
                        logData.longitude
                    );
                } else {
                    console.error(
                        "File reading command ID not present in log file."
                    );
                    continue; // ignore unknown packet types.
                }
            }

            if (readings.length > 0) {
                logData.started_at = new Date(readings[0][0]); // this is also stored on the server, but we do it here so that no server interatction is required when offline.
                logData.ended_at = new Date(readings[readings.length - 1][0]); // provided for user information.
                let durationMin = Math.floor(
                    (readings[readings.length - 1][0] - readings[0][0]) / 60000
                );
                logData.duration = {
                    // provided for user information.
                    days: Math.floor(durationMin / (24 * 60)),
                    hours: Math.floor(durationMin / 60) % 24,
                    minutes: durationMin % 60
                };
            } else {
                logData.started_at = false;
                logData.ended_at = false;
                logData.ended_at = false;
                logData.duration = {
                    // provided for user information.
                    days: 0,
                    hours: 0,
                    minutes: 0
                };
            }

            logData.readings = readings;
            logData.header = header;
            logData.availableGroups = availableGroups;
            logData.header = header;
            logData.generatedTraces = this.generatedTraces;

            if (corruptPacket) {
                console.info(
                    "End of file was reached without decoding another good packet."
                );
            }

            return logData;
        },
        */
        extractLogGroup(groupIndex, numPoints = 2000) {
            let completeLog = this.$store.state.log;
            let generatedTraces = completeLog.generatedTraces;
            let header = completeLog.header;

            let logData = {
                title: this.groupNames[groupIndex],
                columns: ["Date/Time"],
                //readings: [],
                series: {},
                units: [],
                precision: [],
                visibility: [],
                range: [],
                annotations: []
            };

            // Use the devices list setup in the store
            // If the devices is null then the it is not a multiple device request
            const devices = this.$store.state.devices;

            // If the request is for multiple devices
            let traceColors = {};
            if (devices && devices.length > 0) {
                // This predefined color list array defined the colors that would cover a maximum of 12 colors
                // see https://sashamaps.net/docs/resources/20-colors/
                let predefinedColorList = [
                    "#e6194B",
                    "#3cb44b",
                    "#F9A602",
                    "#4363d8",
                    "#911eb4",
                    "#42d4f4",
                    "#f032e6",
                    "#bfef45",
                    "#fabed4",
                    "#469990",
                    "#dcbeff",
                    "#9A6324",
                    "#fffac8",
                    "#800000",
                    "#aaffc3",
                    "#808000",
                    "#ffd8b1",
                    "#000075",
                    "#a9a9a9",
                    "#ffffff",
                    "#000000"
                ];

                header.forEach(({ name }, idx) => {
                    const color =
                        predefinedColorList.length > idx
                            ? predefinedColorList[idx]
                            : "red"; // default to red if cannot find a color
                    traceColors[name] = color;
                });
            } else {
                traceColors = Object.assign({}, this.defaultTraceColors);
            }

            console.log("TraceColors");
            console.log(traceColors);

            // add anciliary data
            let createSeries = (name, units, precision) => {
                logData.series[name] = {
                    color: traceColors[name],
                    //fillAlpha:0.4,
                    fillAlpha: 1.0
                };
                logData.units.push(units);
                logData.precision.push(precision);
                logData.columns.push(name);
                logData.visibility.push(true);
                logData.range = this.groupRanges[groupIndex];
                logData.limits = this.groupLimitBars[groupIndex];
            };

            const traceGroups = this.generateTraceGroups(
                header,
                devices && devices.length > 0
            );

            // work out what traces we need for this group.
            let traceNames = [];
            for (let [key, value] of traceGroups) {
                if (value === groupIndex) {
                    let traceDescription = {
                        name: key
                    };

                    // is this a hard input?
                    for (
                        let headerKey = 0;
                        headerKey < header.length;
                        headerKey++
                    ) {
                        let headerValue = header[headerKey];
                        if (headerValue.name == key) {
                            traceDescription.type = "hard";
                            traceDescription.traceIndex = headerKey;
                            createSeries(
                                key,
                                headerValue.units,
                                headerValue.precision
                            );
                            break;
                        }
                    }

                    // if not a hard input, is it a soft input?
                    if (!traceDescription.type) {
                        for (
                            let genKey = 0;
                            genKey < generatedTraces.length;
                            genKey++
                        ) {
                            let genValue = generatedTraces[genKey];
                            if (genValue.name == key) {
                                if (genValue.present) {
                                    traceDescription.type = "soft";
                                    traceDescription.details = genValue;

                                    createSeries(
                                        key,
                                        genValue.units,
                                        genValue.precision
                                    );
                                }
                                break;
                            }
                        }
                    }

                    // if we found a source for this trace then add it to the list.
                    if (traceDescription.type) {
                        traceNames.push(traceDescription);
                    }
                }
            }

            logData.traceNames = traceNames;
            logData.readings = this.compileReadings(
                completeLog,
                traceNames,
                numPoints
            );

            return logData;
        },
        compileMaxMin(completeLog, traceNames) {
            // used locally to create and init a maxMinRow
            let newMaxMin = (dateVal, dateEnds) => {
                return {
                    date: dateVal,
                    dateEnds: dateEnds,
                    max: {
                        val: new Array(traceNames.length).fill(
                            Number.MIN_SAFE_INTEGER
                        ),
                        date: new Array(traceNames.length)
                    },
                    min: {
                        val: new Array(traceNames.length).fill(
                            Number.MAX_SAFE_INTEGER
                        ),
                        date: new Array(traceNames.length)
                    }
                };
            };

            let logStartDate = new Date(completeLog.readings[0][0]);
            let logEndDate = new Date(
                completeLog.readings[completeLog.readings.length - 1][0]
            );

            let logFirstDayEnds = new Date(
                logStartDate.getFullYear(),
                logStartDate.getMonth(),
                logStartDate.getDate() + 1,
                0,
                0,
                0,
                0
            );
            let logFirstDay = new Date(
                logStartDate.getFullYear(),
                logStartDate.getMonth(),
                logStartDate.getDate(),
                0,
                0,
                0,
                0
            );
            let entireLog = newMaxMin("Entire Log", 0);
            let dayBoundaries = [
                entireLog,
                newMaxMin(logFirstDay.getTime(), logFirstDayEnds.getTime())
            ];
            while (
                dayBoundaries[dayBoundaries.length - 1].dateEnds < logEndDate
            ) {
                dayBoundaries.push(
                    newMaxMin(
                        dayBoundaries[dayBoundaries.length - 1].date +
                            24 * 60 * 60 * 1000,
                        dayBoundaries[dayBoundaries.length - 1].dateEnds +
                            24 * 60 * 60 * 1000
                    )
                );
            }

            let boundaryIdx = 1;
            let dayBoundary = dayBoundaries[boundaryIdx];

            for (let pos = 0; pos < completeLog.readings.length; pos++) {
                // get the data row from the log.
                let reading = this.extractRow(completeLog, pos, traceNames);

                if (dayBoundaries[boundaryIdx].dateEnds <= reading[0]) {
                    boundaryIdx += 1;
                    dayBoundary = dayBoundaries[boundaryIdx];
                }

                for (let col = 1; col < reading.length; col++) {
                    let mmCol = col - 1; // maxmin object column number is one less because there is not date column.

                    let checkMax = subject => {
                        if (
                            reading[col] !== null &&
                            subject.max.val[mmCol] < reading[col]
                        ) {
                            subject.max.val[mmCol] = reading[col];
                            subject.max.date[mmCol] = reading[0];
                        }
                    };

                    let checkMin = subject => {
                        if (
                            reading[col] !== null &&
                            subject.min.val[mmCol] > reading[col]
                        ) {
                            subject.min.val[mmCol] = reading[col];
                            subject.min.date[mmCol] = reading[0];
                        }
                    };

                    checkMax(dayBoundary);
                    checkMin(dayBoundary);
                    checkMax(entireLog);
                    checkMin(entireLog);
                }
            }

            // set to null those values which were not found
            dayBoundaries.map(itm => {
                itm.max.val.map((val, idx) => {
                    if (val == Number.MIN_SAFE_INTEGER) itm.max.val[idx] = null;
                });
                itm.min.val.map((val, idx) => {
                    if (val == Number.MAX_SAFE_INTEGER) itm.min.val[idx] = null;
                });
            });

            return dayBoundaries;
        },
        compileReadings(
            completeLog,
            traceNames,
            startDate,
            endDate,
            numPoints = 2000
        ) {
            let logEndDate =
                completeLog.readings[completeLog.readings.length - 1][0];
            let logStartDate = completeLog.readings[0][0];

            // widen the requeseted detail section so that scrolling still shows detailed data.
            /*
            let padAmount = (endDate - startDate) / 2;
            endDate += padAmount;
            startDate -= padAmount;
            */

            if (
                startDate == null ||
                startDate < logStartDate ||
                startDate > logEndDate
            ) {
                startDate = logStartDate;
            }

            if (
                endDate == null ||
                endDate < logStartDate ||
                endDate > logEndDate
            ) {
                endDate = logEndDate;
            }

            const EXTMAXREADINGS = Math.min(500, completeLog.readings.length);
            const INTMAXREADINGS = Math.min(
                numPoints,
                completeLog.readings.length
            );
            const internalReadingInterval =
                (endDate - startDate) / INTMAXREADINGS;
            const externalReadingInterval =
                (logEndDate - logStartDate) / EXTMAXREADINGS;

            let nextInterval = logStartDate + externalReadingInterval;
            if (nextInterval > startDate) {
                nextInterval = logStartDate + internalReadingInterval;
            }

            let intervalReading = null;
            let intervalAverage = null;
            let readings = [];

            for (let pos = 0; pos < completeLog.readings.length; pos++) {
                // get the data row from the log.
                let reading = this.extractRow(completeLog, pos, traceNames);

                if (intervalReading && reading[0] >= nextInterval) {
                    for (let i = 1; i < intervalReading.length; i++) {
                        if (intervalAverage[i].length > 0) {
                            let sum = (sum = intervalAverage[i].reduce(
                                (a, b) => a + b,
                                0
                            ));
                            let avg = sum / intervalAverage[i].length || 0;
                            intervalReading[i][1] = avg;
                        }
                    }
                    readings.push(intervalReading);
                    intervalReading = null; // this is an array[numchannels] of arrays[3](max, avg, min) to store the compiled reading
                    intervalAverage = null; // this is an array[numchannels] of arrays[numreadings] used to calculate the average which is placed in intervalReading[X][2]

                    if (
                        reading[0] >= startDate - externalReadingInterval &&
                        reading[0] <= endDate
                    ) {
                        // we are currently inside the view window, so use internalReadingInterval
                        nextInterval = reading[0] + internalReadingInterval;
                    } else {
                        nextInterval = reading[0] + externalReadingInterval;
                    }
                }

                if (intervalReading == null) {
                    intervalReading = [reading[0]];
                    intervalAverage = [reading[0]];
                    for (let i = 1; i < reading.length; i++) {
                        let val = reading[i];
                        intervalReading.push([val, val, val]);
                        if (val === null) {
                            intervalAverage.push([]);
                        } else {
                            intervalAverage.push([val]);
                        }
                    }
                } else {
                    for (let i = 1; i < reading.length; i++) {
                        let val = reading[i];
                        let valInterval = intervalReading[i];
                        if (val !== null) {
                            if (valInterval[0] === null) {
                                valInterval[0] = val;
                            } else {
                                valInterval[0] = Math.min(valInterval[0], val);
                            }

                            if (valInterval[2] === null) {
                                valInterval[2] = val;
                            } else {
                                valInterval[2] = Math.max(valInterval[2], val);
                            }

                            intervalAverage[i].push(val);
                        }
                    }
                }
            }

            return readings;
        },
        // utility function which finds the row
        // with the closest matching first column to xval.
        getNearestIndexForX(table, xVal) {
            let low = 0;
            let high = table.length - 1;

            while (low <= high) {
                var idx = (high + low) >> 1;
                let x = table[idx][0];
                if (x < xVal) {
                    low = idx + 1;
                } else if (x > xVal) {
                    high = idx - 1;
                } else {
                    return idx;
                }
            }

            // we didn't get an exact match, so
            // find out whether idx, idx+1 or idx-1 is the
            // nearest match.
            if (
                table[idx + 1] &&
                Math.abs(table[idx][0] - xVal) >
                    Math.abs(table[idx + 1][0] - xVal)
            ) {
                return idx + 1;
            }
            if (
                table[idx - 1] &&
                Math.abs(table[idx][0] - xVal) >
                    Math.abs(table[idx - 1][0] - xVal)
            ) {
                return idx - 1;
            }

            return idx;
        },
        // extracts a single group row from the data,
        // takes care of cacluated traces.
        extractRow(completeLog, rowIndex, traceNames, fillNullColumns = false) {
            if (!completeLog.readings[rowIndex]) {
                console.log(completeLog);
                console.log(rowIndex);
            }

            // create a row with the timestamp.
            let reading = [completeLog.readings[rowIndex][0]];
            let blobValues = completeLog.readings[rowIndex].slice(1);

            // if fillNullColumns is specified, we will grab the nearest valid
            // value for each column that is null.
            if (fillNullColumns) {
                for (var i = 0; i < blobValues.length; i++) {
                    if (blobValues[i] === null) {
                        // find the closest row in the data that isn't null
                        var rowBefore = null,
                            rowAfter = null;
                        for (let j = rowIndex - 1; j >= 0; j--) {
                            if (completeLog.readings[j][i + 1] !== null) {
                                rowBefore = completeLog.readings[j];
                                break;
                            }
                        }
                        for (
                            let j = rowIndex + 1;
                            j < completeLog.readings.length;
                            j++
                        ) {
                            if (completeLog.readings[j][i + 1] !== null) {
                                rowAfter = completeLog.readings[j];
                                break;
                            }
                        }
                        if (rowBefore !== null && rowAfter !== null) {
                            if (
                                rowAfter[0] -
                                    completeLog.readings[rowIndex][0] <
                                completeLog.readings[rowIndex][0] - rowBefore[0]
                            ) {
                                blobValues[i] = rowAfter[i + 1];
                            } else {
                                blobValues[i] = rowBefore[i + 1];
                            }
                        } else if (rowAfter !== null) {
                            blobValues[i] = rowAfter[i + 1];
                        } else if (rowBefore !== null) {
                            blobValues[i] = rowBefore[i + 1];
                        }
                    }
                }
            }

            // populate the values
            for (let key = 0; key < traceNames.length; key++) {
                let value = traceNames[key];

                if (value.type == "hard") {
                    // just grab the value from the blob row
                    reading.push(blobValues[value.traceIndex]);
                } else if (value.type == "soft") {
                    // gather an array of values
                    let args = [];
                    let requiredTraces = value.details.requiredTraceIndices;
                    for (let k = 0; k < requiredTraces.length; k++) {
                        args.push(blobValues[requiredTraces[k]]);
                    }
                    // calculate the value
                    let val = value.details.conversion(...args);
                    // round to appropriate number of digits
                    val = parseFloat(val.toFixed(value.details.precision));

                    reading.push(val);
                }
            }

            return reading;
        }
        // *************************************************************************************************************************************
    }
};
